import React, { Component, CSSProperties } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import Map from "../Map/Map";
import { Circle, InfoWindow, Marker } from "react-google-maps";
import { I8N, StringUtil } from "@eres/core";
import { JQModal } from "../Popup/Utils";
import { AppConstants } from "../../configApp";
import { RTOffice } from "@eres/rtregistrationapi/entities";

interface Props {
	rtOffices: RTOffice[];
	onDismiss: ( office?: RTOffice ) => void;
}

interface State {
	currentLoc?: {
		lat: number,
		lng: number,
	};
	rtOffices: RTOffice[];
	selRTOffice?: RTOffice;
}

class RTOfficeOnMapPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			rtOffices: props.rtOffices,
		};
	}

	componentDidMount() {
		if ( "geolocation" in navigator ) {
			navigator.geolocation.getCurrentPosition( ( position ) => {
				const currentLoc = { lat: position.coords.latitude, lng: position.coords.longitude };
				this.setState( {
					currentLoc: currentLoc,
				} );
			}, ( reason ) => {
			}, { enableHighAccuracy: true, maximumAge: 60000, timeout: 10000 } );
		}
	}

	render() {
		const { currentLoc, rtOffices, selRTOffice } = this.state;
		return <Popup
			id={ "RTOfficeOnMapPopup" }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.rt_office }
			contentHeight={ "450" }
			onDismiss={ () => this.dismissModel() }>
			<Map
				googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCQP3C1vYfBvwfAMK5ryyJ8McbbnCylhjs"
				loadingElement={ <div style={ { height: "100%" } }>
                    <span className="spinner-border" role="status" style={ { position: "absolute" } }>
                       <span className="sr-only">{ Strings.loading }</span>
                   </span>
				</div> }
				containerElement={ <div style={ containerStyle }/> }
				mapElement={ <div style={ { height: "100%" } }/> }
				center={ currentLoc }
				zoom={ currentLoc ? 14 : 11 }>
				{ currentLoc && <RenderCurrentLocation currentLoc={ currentLoc }/> }
				{ rtOffices && rtOffices.length > 0 && rtOffices.map( ( rtOffice: RTOffice ) => {
					if ( rtOffice && rtOffice.Latitude && rtOffice.Longitude ) {
						const position = { lat: rtOffice.Latitude, lng: rtOffice.Longitude };
						return <Marker
							key={ "" + rtOffice.Identity }
							position={ position }
							onClick={ () => this.onMarkerClick( rtOffice ) }>
							{ selRTOffice && selRTOffice.Identity === rtOffice.Identity &&
								<InfoWindow
									position={ position }
									onCloseClick={ () => this.onMarkerClick( undefined ) }>
									<RenderInfo
										rtOffice={ selRTOffice }
										onRTOfficeSelect={ ( office: RTOffice ) => this.dismissModel( office ) }/>
								</InfoWindow> }
						</Marker>;
					}
					return undefined;
				} ) }
			</Map>
		</Popup>;
	}

	private onMarkerClick( rtOffice?: RTOffice ) {
		this.setState( { selRTOffice: rtOffice } );
	}

	private dismissModel( office?: RTOffice ) {
		JQModal( "RTOfficeOnMapPopup" ).hide();
		this.props.onDismiss( office );
	}
}

function RenderCurrentLocation( props: { currentLoc: { lat: number, lng: number } } ) {
	const { currentLoc } = props;
	return <React.Fragment>
		<Marker
			position={ currentLoc }
			icon={ {
				url: `${ AppConstants.rootUrl }/assets/img/current_loc_marker.svg`,
				scaledSize: new google.maps.Size( 35, 35 )
			} }/>
		<Circle
			defaultCenter={ currentLoc }
			radius={ 100 }
			options={ {
				strokeColor: "#00893E", strokeOpacity: 0.8,
				strokeWeight: 2, fillColor: "#00893E", fillOpacity: 0.35
			} }/>
	</React.Fragment>;
}

function RenderInfo( props: { rtOffice: RTOffice, onRTOfficeSelect: ( rtOffice: RTOffice ) => void } ) {
	const { rtOffice, onRTOfficeSelect } = props;
	let image = rtOffice!.CompanyLogo;
	if ( image == undefined || StringUtil.isEmptyStringOrNull( image ) )
		image = `${ AppConstants.rootUrl }/assets/img/no-image.jpg`;
	return <div className="card-detail card-detail-max-width rt-card-detail">
		<div className="card">
			<div className="card-body custom-body">
				<div className="img-holder">
					<div className="box-img">
						<img
							src={ image }
							alt="No Image"
							className="img-fluid"
							onError={ ( event: React.SyntheticEvent<HTMLImageElement, Event> ) => {
								if ( event.target && event.target instanceof HTMLImageElement )
									event.target.src = `${ AppConstants.rootUrl }/assets/img/no-image.jpg`;
							} }/>
					</div>
				</div>
				<div className="detail-holder">
					<div className="custom-card-title">
						<div className="me-auto">{ I8N.isRTL() ? rtOffice!.NameAr : rtOffice!.NameEn }</div>
					</div>
					<div className="starrr"/>
					<ul className="list-style font-size14">
						<li id="office-number-{{index}}">{ Strings.office_number } : { rtOffice!.CompanyNumber }</li>
						<li id="license-number-{{index}}">{ Strings.license_number } : { rtOffice!.LicenseNumber }</li>
						<li id="address-{{index}}">{ Strings.address } : { rtOffice!.Address }</li>
						<li className="email" id="email-{{index}}">
							<i className="far fa-envelope"/>
							<a
								href={ `mailto:${ rtOffice!.Email }` }
								className="underline">{ rtOffice!.Email }
								<span className="sr-only">{ Strings.email }</span></a>
						</li>
						<li className="call" id="phone-{{index}}">
							<i className="fa fa-phone"/>
							<a href={ `tel:${ rtOffice!.Phone }` }>{ rtOffice!.Phone }
								<span className="sr-only">{ Strings.phone }</span></a>
						</li>
					</ul>
					<button
						className="btn btn_1 btn-rt-view btn-sm" type="button"
						onClick={ () => onRTOfficeSelect( rtOffice ) }>{ Strings.select }</button>
				</div>
			</div>
		</div>
	</div>;
}

const containerStyle: CSSProperties = {
	position: "absolute",
	width: "100%",
	height: "100%",
	left: 0,
	right: 0,
	top: 0,
	bottom: 0
};

export default RTOfficeOnMapPopup;
